import React, {Component} from 'react';
import {Icon} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import {Actions} from '../../actions';
import UndefinedStoreVariableError from '../../exceptions/UndefinedStoreVariableError';
import './messageBox.scss';

class MessageBox extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.showMessage = this.showMessage.bind(this);
    this.generateData = this.generateData.bind(this);
    this.dismiss = this.dismiss.bind(this);
    this.closeOnKeyDown = this.closeOnKeyDown.bind(this);
  }

  generateData() {
    if (this.props.error) {
      return {
        'message': this.props.error,
        'color': 'red',
        'icon': 'close',
      };
    }
    if (this.props.warning) {
      return {
        'message': this.props.warning,
        'color': 'yellow',
        'icon': 'warning sign',
      };
    }
    return {
      'message': this.props.info,
      'color': 'green',
      'icon': 'check',
    };
  }

  showMessage() {
    return (
      this.props &&
      this.props.show &&
      (this.props.error || this.props.warning || this.props.info)
    );
  }

  dismiss(event) {
    event.preventDefault();
    this.props.dismissMessageBox();
  }

  closeOnKeyDown(event) {
    const enterKeyCode = 13;
    event.stopPropagation();
    event.preventDefault();

    if (event.keyCode === enterKeyCode) {
      this.props.dismissMessageBox();
    }
  }

  generateMessageBox() {
    const data = this.generateData();
    const {show, error} = this.props;
    const messageType = show && error ? 'errorMessage' : 'successMessage';
    return (
      <CSSTransition classNames='message' timeout={500}>
        <div tabIndex='0'>
          {error && <div className='dimmer' />}
          <div className={`MessageBox ${messageType}`}>
            <Icon circular inverted color={data.color} name={data.icon} size="large" />
            <div className="`ui black message">
              <div>{data.message}</div>
            </div>
            <div className='close-message-box' onClick={this.dismiss}>
              X
            </div>
          </div>
        </div>
      </CSSTransition>
    );
  }

  componentDidUpdate(prevProps) {
    const hideTime = this.props.hideTime || 10000;
    const {show, error} = this.props;
    if (show) {
      document.body.addEventListener('keydown', this.closeOnKeyDown);
      document.body.focus();
    }

    if (show && !error) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => this.props.dismissMessageBox(), hideTime);
    }

    if (!show) {
      document.body.removeEventListener('keydown', this.closeOnKeyDown);
    }
  }

  render() {
    return (
      <TransitionGroup>
        {this.showMessage() && this.generateMessageBox()}
      </TransitionGroup>
    );
  }
}

const mapStateToProps = (state) => {
  if (!state || !state.messageBox) {
    throw new UndefinedStoreVariableError('messageBox');
  }
  return {
    'error': state.messageBox.error,
    'warning': state.messageBox.warning,
    'info': state.messageBox.info,
    'show': state.messageBox.show,
    'hideTime': state.messageBox.hideTime,
  };
};

const {dismissMessageBox} = Actions;

export default connect(mapStateToProps, {dismissMessageBox})(MessageBox);
